export interface LoginValues {
  email: string;
  password: string;
}

/** Message per missing field; an empty object when both are filled in. */
export type MissingFields = { email?: string; password?: string };

export function missingFields({ email, password }: LoginValues): MissingFields {
  return {
    email: email.trim() ? undefined : "Enter your email.",
    password: password ? undefined : "Enter your password.",
  };
}

export function isComplete(missing: MissingFields): boolean {
  return !missing.email && !missing.password;
}

export function rememberMeLabel(days: number): string {
  return `Keep me signed in for ${days === 1 ? "1 day" : `${days} days`}`;
}
